<template lang="pug">
  #MyCustomer
    appHeader
    router-view.content-body-hasFooter
    appSaFooter
</template>

<script>
import appHeader from '@/components/partials/AppHeader.vue';
import appSaFooter from '@/components/partials/AppSaFooter.vue';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'MyCustomerComponent',
  components: {
    appHeader,
    appSaFooter
  }
};
</script>
